"use client";

import { useLanguage } from "../../context/LanguageContext";
import { Header } from "../Header";
import SiteFooter from "../SiteFooter";
import ContactSection from "../sections/ContactSection";

export default function ContactPage(): JSX.Element {
  const { t } = useLanguage();

  return (
    <div className="flex min-h-screen flex-col" dir={t.common.dir} lang={t.common.lang}>
      <Header />
      <main className="flex-1">
        <ContactSection headingLevel="h1" />
      </main>
      <SiteFooter />
    </div>
  );
}
